import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const pt = {
  common: {
    open: "Abrir", copy: "Copiar", copied: "Copiado", save: "Salvar", cancel: "Cancelar", delete: "Excluir",
    edit: "Editar", back: "Voltar", loading: "Carregando...", sending: "Enviando...", send: "Enviar",
    close: "Fechar", search: "Buscar", saving: "Salvando...", panel: "Painel", enter: "Entrar",
    prices: "Preços", freePlan: "Plano Grátis", proPlan: "Plano Pro · Ilimitado", upgrade: "Fazer upgrade",
    paidPlan: "Plano {{plan}} · Ilimitado",
    exportCsv: "Exportar CSV", copyLink: "Copiar link", copyCode: "Copiar código", langLabel: "Idioma",
    billing: "Cobrança",
    yes: "Sim", no: "Não",
  },
  nav: { pricing: "Preços", dashboard: "Painel", login: "Entrar" },
  landing: {
    badge: "Feito no Brasil · LGPD",
    heroTitle: ["Depoimentos", "em vídeo", ", direto", "no seu site."],
    heroSub: "Envie um link. O cliente grava sozinho pelo celular. Você aprova e o mural aparece no seu site. Sem edição, sem vai-e-vem.",
    ctaStart: "Começar grátis", ctaMinutes: "Login com Google · 30 segundos",
    trust: "Funciona em qualquer plataforma",
    howTitle: ["Do link ao mural pronto em", "3 passos", "."],
    howKicker: "Como funciona",
    step1Title: "Crie sua campanha e compartilhe o link",
    step1Desc: "Você cria uma campanha com o nome da marca, as perguntas e uma mensagem personalizada. Recebe um link único (com QR code inclusive) pra mandar por WhatsApp, email ou colar na embalagem.",
    step2Title: "Cliente grava em segundos pelo celular",
    step2Desc: "Ele abre o link, escolhe vídeo, voz ou texto, grava sozinho e envia. Sem conta, sem app. Você recebe a transcrição automática por IA e ainda pode subir uma foto do autor pro mural ficar humano.",
    step3Title: "Aprove e cole o widget no seu site",
    step3Desc: "Um clique aprova. O mural fica online na hora — cores, tema, layout e ordenação personalizáveis. Uma linha de HTML e aparece em qualquer site: WordPress, Shopify, Wix, Webflow, Framer.",
    embedKicker: "Sem código",
    embedTitle: ["Cole no seu site em", "30 segundos", "."],
    embedDesc: "Uma tag de iframe. Um copiar e colar. O mural fica responsivo, com suas cores, e atualiza sozinho toda vez que você aprovar um novo depoimento.",
    embedFeatures: ["Cores e tema personalizáveis", "Layout mural, grade ou lista", "Ordem por recentes, melhor nota ou aleatória", "Funciona em qualquer construtor"],
    embedCopy: "Copiar", embedCopied: "Copiado",
    showcaseKicker: "Prova real",
    showcaseTitle: "Rostos de clientes que já mandaram depoimento pelo depoia",
    featureAiTitle: "IA que transcreve e resume",
    featureAiDesc: "Depoimentos em vídeo/voz viram texto na hora, com sugestão de frase de destaque.",
    featureLgpdTitle: "Consentimento LGPD embutido",
    featureLgpdDesc: "Cada depoimento vem com autorização explícita registrada. Suas páginas de privacidade e termos incluídas.",
    featureWidgetTitle: "Widget que se adapta",
    featureWidgetDesc: "Um mesmo widget muda cor, tema, layout e ordem por campanha. Sem tocar no código do site.",
    ctaQuote: '"Pedir depoimento era constrangedor e demorado. Agora eu só mando o link e eles chegam prontos."',
    ctaSub: "O tipo de resultado que seus clientes vão entregar para você.",
    ctaFinal: "Criar minha primeira campanha", ctaSeePlans: "Ver planos →",
    footerTag: "depoia — depoimentos que vendem por você.",
    privacy: "Política de Privacidade", terms: "Termos de Uso",
  },
  login: { title: "Entrar", sub: "Use sua conta Google para criar campanhas e gerenciar depoimentos.", btn: "Continuar com Google", small: "Sem cartão de crédito. Sem instalação." },
  dashboard: {
    freeUsage: "{{textUsed}}/{{textLimit}} textos · {{mediaUsed}}/{{mediaLimit}} vídeo/voz",
    freeHint: "Depoimentos além do limite chegam bloqueados. Faça upgrade para liberar tudo.",
    campaigns: "Campanhas", campaignsSub: "Cada campanha tem um link de coleta e um mural próprio.",
    newCampaign: "Nova campanha", emptyMsg: "Nenhuma campanha ainda. Crie a primeira e comece a coletar depoimentos.",
    emptyBtn: "Criar campanha", testimonials: "depoimentos", wallCount: "no mural",
    digestTitle: "Resumo semanal por email",
    digestDesc: "Toda sexta às 09h você recebe as estatísticas da semana e os melhores depoimentos para publicar nas redes.",
    digestPreview: "Enviar prévia", digestOn: "Resumo semanal ativado", digestOff: "Resumo semanal pausado",
    digestSent: "Prévia enviada para {{email}}", digestFail: "Erro ao enviar prévia",
    linkCopied: "Link de coleta copiado!",
    adminPanel: "Painel Admin",
    adminPanelTitle: "Ver MRR, conversões e lista de usuários",
    adminExportUsers: "Exportar usuários",
    adminExportUsersTitle: "Baixar CSV com todos os assinantes e leads (admin)",
    adminExportSuccess: "CSV de usuários baixado!",
    adminExportError: "Erro ao exportar usuários. Você tem acesso admin?",
  },
  campaignForm: {
    newTitle: "Nova campanha", editTitle: "Editar campanha",
    businessName: "Nome do negócio", businessNamePh: "Studio Aurora",
    welcome: "Mensagem de boas-vindas", welcomePh: "Ex: Oi! Adoraríamos ouvir como foi sua experiência com a gente. Leva menos de 2 minutos.",
    thankyou: "Mensagem de agradecimento",
    thankyouHint: "Aparece na tela depois que o cliente envia o depoimento. Se deixar em branco, mostramos uma mensagem padrão.",
    thankyouPh: "Ex: Muito obrigado! Como agradecimento, você ganhou 10% off na próxima compra — código: OBRIGADO10.",
    questions: "Perguntas guias (até 4)", questionsHint: "Aparecem na página como sugestões pro cliente.",
    addQuestion: "+ Adicionar pergunta", saveCreate: "Criar campanha", saveEdit: "Salvar alterações",
    created: "Campanha criada!", saved: "Alterações salvas!", saveError: "Erro ao salvar. Tente novamente.",
    countdownLabel: "Contagem regressiva antes de gravar",
    countdownHint: "Dá tempo do cliente respirar antes da câmera/mic começar. Aplica a vídeo e voz.",
    countdownOff: "Desligado",
    localeLabel: "Idioma da página de coleta",
    localeHint: "Define em que idioma o cliente vê a página de gravação. Independe do idioma que ele usa no navegador.",
  },
  campaignDetail: {
    back: "Painel", collectLink: "Link de coleta", embedCode: "Código de incorporação",
    embedDesc: "Cole no seu site (WordPress, Wix, qualquer um) para exibir o mural de depoimentos aprovados.",
    seeCode: "Ver código", seeWall: "Ver mural", qrTitle: "QR code do link",
    qrDesc: "Imprima e cole no balcão, na embalagem ou no material impresso. Ao apontar a câmera, seu cliente abre a página de gravação.",
    downloadPng: "Baixar PNG", qrDownloaded: "QR code baixado!",
    ratings: "avaliações", appearance: "Aparência do mural", appearanceSub: "Combine o widget com o visual do seu site.",
    accent: "Cor de destaque", theme: "Tema", themeLight: "Claro", themeDark: "Escuro",
    layout: "Layout", layoutMasonry: "Mural", layoutGrid: "Grade", layoutList: "Lista",
    order: "Ordem", orderRecent: "Mais recentes", orderTop: "Melhor nota", orderRandom: "Aleatória",
    orderHint: "O destaque fixado sempre aparece primeiro.", saveAppearance: "Salvar aparência",
    preview: "Pré-visualização", inbox: "Inbox", testimonialsCount: "{{count}} depoimentos",
    approved: "Aprovados", pending: "Pendentes",
    searchPlaceholder: "Buscar por nome ou texto...",
    emptyInbox: "Nenhum depoimento ainda. Compartilhe o link de coleta.",
    approve: "Aprovar", unapprove: "Desaprovar", pin: "Fixar", unpin: "Desfixar",
    editHighlight: "Editar destaque", editTranscript: "Editar transcrição",
    highlight: "Destaque", generateHighlight: "Gerar destaque com IA",
    transcript: "Transcrição", transcriptStatusPending: "Transcrevendo...", transcriptStatusFailed: "Falha na transcrição",
    codeCopied: "Código copiado!", waMessage: "Mensagem no WhatsApp",
    embedScriptLabel: "Recomendado · com SEO",
    embedScriptHint: "Os depoimentos entram no HTML da sua página, com as estrelas em formato que o Google entende (rich snippet). Respeita as cores, o tema e a ordem que você configurou aqui.",
    embedIframeLabel: "Alternativa · iframe clássico",
    embedIframeHint: "Use se o seu site não permite <script>. Funciona igual visualmente, mas o Google não lê os depoimentos.",
    waEditTitle: "Mensagem padrão do WhatsApp", waHint: "Personalize o que seus clientes recebem quando você clica no botão do WhatsApp.",
    waSave: "Salvar mensagem", waSaved: "Mensagem salva!",
    deleteConfirm: "Excluir depoimento?", deleteConfirmDesc: "Esta ação não pode ser desfeita. O vídeo/áudio também será removido.",
    deleteCampaignConfirm: "Excluir campanha?", deleteCampaignDesc: "Isso apagará todos os depoimentos e mídia relacionados.",
    exportSuccess: "Planilha baixada!", exportError: "Erro ao exportar. Tente novamente.",
    exportHint: "Baixe todos os depoimentos em CSV para usar em outros materiais.",
    pinned: "Destaque",
  },
  record: {
    fallSobre: "VOCÊ PODE FALAR SOBRE", askQuestion: "Como você prefere deixar seu depoimento?",
    modeVideo: "Vídeo", modeAudio: "Voz", modeText: "Escrever",
    yourRating: "Sua nota", yourName: "Seu nome *", yourEmail: "Seu email *", emailPrivate: "Seu email não será exibido publicamente.",
    yourRole: "Cargo / Empresa", rolePh: "CEO, Empresa X",
    yourPhoto: "Sua foto (opcional)", changePhoto: "Trocar foto", addPhoto: "Adicionar foto",
    photoHint: "JPG, PNG ou WebP, até 5MB.", photoTooLarge: "Foto muito grande (máx. 5MB)",
    textPh: "Conte um pouco sobre sua experiência...",
    consent: "Autorizo o uso deste depoimento por <strong>{{business}}</strong> em seu site e materiais de divulgação, conforme a <a>Política de Privacidade</a> e os <b>Termos de Uso</b>. Meu email não será exibido publicamente.",
    consentRequired: "Confirme a autorização para publicarmos seu depoimento.",
    recordFirst: "Grave seu depoimento antes de enviar", fillNameEmail: "Preencha nome e email",
    submit: "Enviar depoimento", errorSend: "Erro ao enviar. Tente novamente.",
    paused: "Esta coleta está pausada no momento. Fale com quem te enviou o link.",
    pausedShort: "Esta coleta está pausada no momento. Fale com quem te enviou o link.",
    notFound: "Campanha não encontrada",
  },
  thankyou: { title: "Obrigado!", defaultMsg: "Seu depoimento foi enviado com sucesso. Ele significa muito — de verdade.", closeHint: "Você já pode fechar esta página." },
  widget: { pinnedBadge: "Destaque", ratingLabel: "avaliações" },
  pricing: {
    title: "Escolha o plano ideal", sub: "Comece grátis. Cresça sem susto.",
    monthly: "Mensal", yearly: "Anual", yearlyBadge: "-20%",
    freeName: "Grátis", freeDesc: "Pra testar e coletar seus primeiros depoimentos.",
    proName: "Pro", proDesc: "Pra negócios que crescem com prova social.",
    growthName: "Growth", growthDesc: "Pra quem já usa depoimento como canal de venda.",
    agencyName: "Agência", agencyDesc: "Pra agências e quem gerencia várias marcas.",
    trialBadge: "14 dias grátis",
    trialNote: "14 dias grátis, sem cartão. Depois do teste você escolhe como pagar.",
    startTrial: "Começar 14 dias grátis",
    monthEq: "Equivale a {{value}}/mês — você paga 10 meses, usa 12",
    features: {
      freeCollect: "Até 10 depoimentos em texto",
      freeMedia: "2 depoimentos em vídeo/voz",
      freeCampaigns: "1 campanha ativa",
      freeWidget: "Widget com marca depoia",
      proUnlimited: "Depoimentos ilimitados (texto, vídeo, voz)",
      proCampaigns: "Campanhas ilimitadas",
      proNoBrand: "Widget sem marca depoia",
      proAi: "Transcrição e destaque com IA",
      proExport: "Exportar em CSV",
      proSupport: "Suporte prioritário",
      growthAll: "Tudo do Pro, mais:",
      growthReels: "Exportar vídeo pronto pra Reels/TikTok",
      growthDigest: "Resumo semanal por email",
      growthMultiLang: "Murais em português e inglês",
      growthSupport: "Suporte prioritário por email",
      agencyAll: "Tudo do Growth, mais:",
      agencyBrands: "Várias marcas e clientes na mesma conta",
      agencyOnboarding: "Onboarding assistido 1:1",
      agencyWhatsapp: "Suporte por WhatsApp",
      agencyPriority: "Prioridade em novas funcionalidades",
    },
    current: "Plano atual", subscribe: "Assinar",
  },
  billing: {
    title: "Cobrança", sub: "Veja seu plano, troque quando quiser e cancele sozinho.",
    currentPlan: "Plano atual",
    statusFree: "Você está no plano grátis.",
    statusTrial: "Teste grátis até {{date}}. Depois disso a cobrança começa.",
    statusActive: "Ativo · próxima cobrança em {{date}}",
    statusCanceling: "Cancelado · você mantém o acesso até {{date}}",
    statusPastDue: "Pagamento pendente — atualize sua forma de pagamento.",
    needsCard: "Seu teste grátis está rolando e ainda não temos uma forma de pagamento. Adicione um cartão para não perder o acesso quando o teste terminar.",
    addCard: "Adicionar forma de pagamento", changeCard: "Trocar cartão", noCard: "Nenhum cartão salvo",
    cardSaved: "Forma de pagamento salva!",
    cancel: "Cancelar assinatura", confirmCancel: "Sim, cancelar", keepPlan: "Manter meu plano",
    cancelConfirmTitle: "Cancelar sua assinatura?",
    cancelConfirmDesc: "Você continua com tudo liberado até {{date}} e não haverá nova cobrança. Pode reativar antes dessa data.",
    canceledToast: "Assinatura cancelada. Você mantém o acesso até o fim do período pago.",
    resume: "Reativar assinatura", resumedToast: "Assinatura reativada!",
    changePlanTitle: "Trocar de plano",
    changePlanDesc: "A troca vale na hora. O Stripe calcula o valor proporcional do que você já pagou.",
    switchTo: "Trocar para este plano",
    switchConfirmTitle: "Trocar para o {{plan}}?",
    switchConfirmDesc: "A mudança acontece agora. Você recebe crédito ou uma cobrança proporcional aos dias restantes.",
    planChanged: "Plano alterado para {{plan}}!",
    invoices: "Faturas", receipt: "Recibo",
    invStatus: { paid: "Pago", open: "Em aberto", draft: "Rascunho", void: "Cancelada", uncollectible: "Não paga" },
    genericError: "Não conseguimos concluir. Tente novamente.",
  },
  legal: {
    privacyTitle: "Política de Privacidade", termsTitle: "Termos de Uso",
    lastUpdate: "Última atualização: agosto de 2026",
    seeTerms: "Ver Termos de Uso", seePrivacy: "Ver Política de Privacidade",
  },
  integrations: {
    kicker: "Guias sem código",
    title: "Cole o depoia em qualquer site em 30 segundos.",
    subtitle: "Um snippet de iframe. Zero plugin. Escolha a plataforma que você usa e siga o passo a passo.",
    footerLink: "Integrações",
    snippetLabel: "Snippet universal (com SEO)",
    iframeLabel: "Alternativa · iframe",
    iframeHint: "Use em plataformas que bloqueiam <script> (Wix, Notion). Visualmente igual, mas o Google não lê os depoimentos.",
    replaceHint: "Troque \"sua-marca\" pelo slug da sua campanha (você encontra em Painel → Campanha → Código de incorporação).",
    copied: "Snippet copiado!",
    tipLabel: "Dica:",
    helpTitle: "Precisa de uma mãozinha?",
    helpDesc: "Manda um email pra gente que a gente instala junto com você.",
    ctaTitle: "Ainda não tem uma campanha?",
    ctaSub: "Cria a sua conta grátis, monta a campanha em 2 minutos e volta aqui pra colar o widget.",
    platforms: {
      wordpress: {
        name: "WordPress",
        intro: "Funciona em qualquer tema. O snippet vai dentro de um bloco de HTML personalizado.",
        step1: "No painel do WordPress, edite a página ou post onde quer mostrar os depoimentos.",
        step2: "Clique em <strong>+ Adicionar bloco</strong> e busque por <strong>HTML personalizado</strong> (Custom HTML).",
        step3: "Cole o snippet do depoia dentro do bloco.",
        step4: "Clique em <strong>Atualizar</strong> ou <strong>Publicar</strong>. Pronto — o mural já aparece.",
        tip: "Se você usa Elementor, use o widget <em>HTML</em> e cole o mesmo snippet lá dentro.",
      },
      webflow: {
        name: "Webflow",
        intro: "O depoia aparece como um <em>Embed</em> nativo. Zero JavaScript pra configurar.",
        step1: "Abra o Webflow Designer e navegue até a página desejada.",
        step2: "Arraste o elemento <strong>Embed</strong> (dentro de Components → Advanced) para o local onde o mural deve aparecer.",
        step3: "Cole o snippet no editor de código do Embed e clique em <strong>Save & Close</strong>.",
        step4: "Publique o site com <strong>Publish</strong> no canto superior direito.",
        tip: "O Embed do Webflow tem limite de 10.000 caracteres — o snippet do depoia usa menos de 200. Fica tranquilo.",
      },
      shopify: {
        name: "Shopify",
        intro: "Mostre depoimentos na página inicial, em produto ou na página \"Sobre\" — sem editar o tema.",
        step1: "No admin da Shopify, vá em <strong>Loja online → Páginas</strong> (ou <strong>Personalizar</strong> se for a home).",
        step2: "Adicione uma seção do tipo <strong>HTML personalizado</strong> ou edite a página com o editor de código-fonte.",
        step3: "Cole o snippet do depoia e salve.",
        step4: "Visualize a loja para conferir. O mural fica responsivo em mobile automaticamente.",
        tip: "Nos temas Dawn/Sense, use a seção <em>Custom Liquid</em> — o comportamento é idêntico.",
      },
      wix: {
        name: "Wix",
        intro: "Wix bloqueia scripts, mas o iframe do depoia passa direto pelo <em>Embed HTML</em>.",
        step1: "No editor do Wix, clique em <strong>+ Adicionar</strong> → <strong>Embed</strong> → <strong>Embed HTML</strong>.",
        step2: "Escolha a opção <strong>Código</strong> e cole o snippet do depoia.",
        step3: "Redimensione a caixa do embed para caber o mural (recomendado: 100% de largura, altura 640px).",
        step4: "Clique em <strong>Publicar</strong> no canto superior direito.",
        tip: "Se estiver no Wix Studio, use o componente <em>Custom Element</em> ou <em>Embed HTML</em> — funciona igual.",
      },
      squarespace: {
        name: "Squarespace",
        intro: "Precisa de um plano <em>Business</em> ou superior (por causa do Code Block).",
        step1: "Edite a página e clique no botão <strong>+</strong> para adicionar um bloco.",
        step2: "Escolha o bloco <strong>Code</strong> e selecione a linguagem <strong>HTML</strong>.",
        step3: "Cole o snippet do depoia e desmarque a opção <em>Display Source</em>.",
        step4: "Clique fora do bloco e salve. Publique a página.",
        tip: "Se o mural ficar cortado, aumente a altura no atributo <code>height=\"800\"</code> do iframe.",
      },
      framer: {
        name: "Framer",
        intro: "Framer suporta iframe nativamente através do componente <em>Embed</em>.",
        step1: "No editor do Framer, arraste o componente <strong>Embed</strong> (Insert → Embed) para a página.",
        step2: "Cole o snippet do depoia no campo <em>HTML</em> do painel direito.",
        step3: "Publique o site com <strong>Publish</strong>.",
        tip: "Deixe o Embed em largura <em>Fill</em> e altura fixa de 640px para melhor visual em mobile.",
      },
      notion: {
        name: "Notion",
        intro: "Perfeito para páginas públicas do Notion (portfólios, wikis, landing pages simples).",
        step1: "Cole o link público do seu mural no Notion — ex: <code>https://depoia.com.br/w/sua-marca</code>.",
        step2: "Escolha a opção <strong>Create embed</strong> no menu que aparecer.",
        step3: "Redimensione o bloco arrastando a alça inferior. Publique a página.",
        tip: "O Notion não permite iframe com JavaScript avançado — nosso widget já é otimizado pra rodar direto no embed.",
      },
      carrd: {
        name: "Carrd",
        intro: "O jeito mais rápido de ter uma landing page com prova social real.",
        step1: "Adicione um elemento <strong>Embed</strong> na sua página (precisa do plano Pro Standard ou superior).",
        step2: "Escolha o tipo <strong>Code</strong>, estilo <strong>Hidden</strong> ou <strong>Inline</strong>, e cole o snippet.",
        step3: "Salve e publique. O widget aparece na hora.",
        tip: "Se quiser um mural mais alto, edite o atributo <code>height</code> do iframe direto no snippet.",
      },
      bubble: {
        name: "Bubble",
        intro: "Bubble aceita HTML puro em qualquer página através do elemento <em>HTML</em>.",
        step1: "No editor do Bubble, arraste o elemento <strong>HTML</strong> para a página.",
        step2: "Cole o snippet do depoia no campo <em>HTML</em> das propriedades do elemento.",
        step3: "Preview e publique. Zero configuração extra.",
        tip: "Ajuste a largura do elemento para 100% do container pra ficar responsivo em qualquer breakpoint.",
      },
      html: {
        name: "HTML puro",
        intro: "Qualquer site estático, framework ou landing custom. Cole no HTML e pronto.",
        step1: "Abra o arquivo HTML da página onde quer mostrar os depoimentos.",
        step2: "Cole o snippet no local exato onde o mural deve aparecer. Salve e faça deploy.",
        tip: "Funciona em Next.js, Astro, Hugo, Jekyll, Vite, etc. Basta usar dentro do JSX ou template do seu framework.",
      },
    },
  },
};

const en = {
  common: {
    open: "Open", copy: "Copy", copied: "Copied", save: "Save", cancel: "Cancel", delete: "Delete",
    edit: "Edit", back: "Back", loading: "Loading...", sending: "Sending...", send: "Send",
    close: "Close", search: "Search", saving: "Saving...", panel: "Dashboard", enter: "Sign in",
    prices: "Pricing", freePlan: "Free plan", proPlan: "Pro plan · Unlimited", upgrade: "Upgrade",
    paidPlan: "{{plan}} plan · Unlimited",
    exportCsv: "Export CSV", copyLink: "Copy link", copyCode: "Copy code", langLabel: "Language",
    billing: "Billing",
    yes: "Yes", no: "No",
  },
  nav: { pricing: "Pricing", dashboard: "Dashboard", login: "Sign in" },
  landing: {
    badge: "Made in Brazil · GDPR-ready",
    heroTitle: ["Video", "testimonials", ", straight", "on your site."],
    heroSub: "Send a link. Your customer records on their phone in seconds. You approve and the wall appears on your site. No editing, no back-and-forth.",
    ctaStart: "Start free", ctaMinutes: "Google login · 30 seconds",
    trust: "Works on any platform",
    howTitle: ["From link to live wall in", "3 steps", "."],
    howKicker: "How it works",
    step1Title: "Create your campaign and share the link",
    step1Desc: "Set up a campaign with your brand name, questions and a personal welcome. You get a unique link (with QR code) to send via WhatsApp, email or paste on packaging.",
    step2Title: "Your customer records in seconds on their phone",
    step2Desc: "They open the link, pick video, voice or text, record on their own and submit. No account, no app. You get the AI transcript instantly and can add the author's photo to make the wall more human.",
    step3Title: "Approve and paste the widget on your site",
    step3Desc: "One click approves. The wall goes live instantly — colors, theme, layout and order all customizable. One line of HTML and it works on any site: WordPress, Shopify, Wix, Webflow, Framer.",
    embedKicker: "No-code",
    embedTitle: ["Paste on your site in", "30 seconds", "."],
    embedDesc: "One iframe tag. Copy and paste. The wall is responsive, matches your colors, and refreshes itself every time you approve a new testimonial.",
    embedFeatures: ["Custom colors and theme", "Wall, grid or list layout", "Sort by recent, top-rated or random", "Works with any site builder"],
    embedCopy: "Copy", embedCopied: "Copied",
    showcaseKicker: "Real proof",
    showcaseTitle: "Faces of customers who already sent testimonials via depoia",
    featureAiTitle: "AI transcript + highlight",
    featureAiDesc: "Video/voice testimonials become searchable text instantly, with a suggested headline quote.",
    featureLgpdTitle: "Consent recorded by default",
    featureLgpdDesc: "Every testimonial ships with explicit authorization on file. Privacy Policy and Terms pages included.",
    featureWidgetTitle: "Widget that adapts",
    featureWidgetDesc: "The same widget changes color, theme, layout and order per campaign. No touching your site's code.",
    ctaQuote: '"Asking for testimonials used to be awkward and slow. Now I just send the link and they show up ready to publish."',
    ctaSub: "The kind of result your customers will deliver to you.",
    ctaFinal: "Create my first campaign", ctaSeePlans: "See pricing →",
    footerTag: "depoia — testimonials that sell for you.",
    privacy: "Privacy Policy", terms: "Terms of Service",
  },
  login: { title: "Sign in", sub: "Use your Google account to create campaigns and manage testimonials.", btn: "Continue with Google", small: "No credit card. No install." },
  dashboard: {
    freeUsage: "{{textUsed}}/{{textLimit}} texts · {{mediaUsed}}/{{mediaLimit}} video/voice",
    freeHint: "Testimonials beyond the limit are blocked. Upgrade to unlock everything.",
    campaigns: "Campaigns", campaignsSub: "Each campaign has its own collection link and wall.",
    newCampaign: "New campaign", emptyMsg: "No campaigns yet. Create the first and start collecting testimonials.",
    emptyBtn: "Create campaign", testimonials: "testimonials", wallCount: "on the wall",
    digestTitle: "Weekly summary by email",
    digestDesc: "Every Friday at 9am you get the week's stats and best testimonials to publish on social.",
    digestPreview: "Send preview", digestOn: "Weekly summary enabled", digestOff: "Weekly summary paused",
    digestSent: "Preview sent to {{email}}", digestFail: "Failed to send preview",
    linkCopied: "Collection link copied!",
    adminPanel: "Admin panel",
    adminPanelTitle: "See MRR, conversion and users list",
    adminExportUsers: "Export users",
    adminExportUsersTitle: "Download CSV with every subscriber and lead (admin)",
    adminExportSuccess: "Users CSV downloaded!",
    adminExportError: "Error exporting users. Do you have admin access?",
  },
  campaignForm: {
    newTitle: "New campaign", editTitle: "Edit campaign",
    businessName: "Business name", businessNamePh: "Studio Aurora",
    welcome: "Welcome message", welcomePh: "e.g. Hi! We'd love to hear about your experience with us. Takes less than 2 minutes.",
    thankyou: "Thank-you message",
    thankyouHint: "Shown after the customer submits their testimonial. Leave blank to use the default.",
    thankyouPh: "e.g. Thanks a lot! Here's 10% off your next order — code: THANKS10.",
    questions: "Guiding questions (up to 4)", questionsHint: "Shown on the page as suggestions.",
    addQuestion: "+ Add question", saveCreate: "Create campaign", saveEdit: "Save changes",
    created: "Campaign created!", saved: "Changes saved!", saveError: "Error saving. Please try again.",
    countdownLabel: "Countdown before recording starts",
    countdownHint: "Gives your customer a breath before the camera/mic kicks in. Applies to video and voice.",
    countdownOff: "Off",
    localeLabel: "Collection page language",
    localeHint: "Sets the language of the recording page shown to your customer. Independent of the visitor's browser language.",
  },
  campaignDetail: {
    back: "Dashboard", collectLink: "Collection link", embedCode: "Embed code",
    embedDesc: "Paste on your site (WordPress, Wix, any builder) to show your wall of approved testimonials.",
    seeCode: "View code", seeWall: "View wall", qrTitle: "QR code for the link",
    qrDesc: "Print and stick it on your counter, packaging or printed materials. Point the phone camera and the recording page opens.",
    downloadPng: "Download PNG", qrDownloaded: "QR code downloaded!",
    ratings: "ratings", appearance: "Wall appearance", appearanceSub: "Match the widget to your site's look.",
    accent: "Accent color", theme: "Theme", themeLight: "Light", themeDark: "Dark",
    layout: "Layout", layoutMasonry: "Wall", layoutGrid: "Grid", layoutList: "List",
    order: "Order", orderRecent: "Most recent", orderTop: "Top rated", orderRandom: "Random",
    orderHint: "The pinned highlight always shows first.", saveAppearance: "Save appearance",
    preview: "Preview", inbox: "Inbox", testimonialsCount: "{{count}} testimonials",
    approved: "Approved", pending: "Pending",
    searchPlaceholder: "Search by name or text...",
    emptyInbox: "No testimonials yet. Share the collection link.",
    approve: "Approve", unapprove: "Unapprove", pin: "Pin", unpin: "Unpin",
    editHighlight: "Edit highlight", editTranscript: "Edit transcript",
    highlight: "Highlight", generateHighlight: "Generate highlight with AI",
    transcript: "Transcript", transcriptStatusPending: "Transcribing...", transcriptStatusFailed: "Transcription failed",
    codeCopied: "Code copied!", waMessage: "WhatsApp message",
    embedScriptLabel: "Recommended · SEO-friendly",
    embedScriptHint: "Testimonials are written into your page HTML, with ratings in the format Google understands (rich snippet). Respects the colors, theme and order you set here.",
    embedIframeLabel: "Alternative · classic iframe",
    embedIframeHint: "Use it if your site blocks <script>. Looks the same, but Google can't read the testimonials.",
    waEditTitle: "Default WhatsApp message", waHint: "Customize what your customers receive when you click the WhatsApp button.",
    waSave: "Save message", waSaved: "Message saved!",
    deleteConfirm: "Delete testimonial?", deleteConfirmDesc: "This action can't be undone. The video/audio will also be removed.",
    deleteCampaignConfirm: "Delete campaign?", deleteCampaignDesc: "This will delete all related testimonials and media.",
    exportSuccess: "Spreadsheet downloaded!", exportError: "Error exporting. Please try again.",
    exportHint: "Download every testimonial as CSV to use in other materials.",
    pinned: "Highlight",
  },
  record: {
    fallSobre: "YOU CAN TALK ABOUT", askQuestion: "How do you prefer to leave your testimonial?",
    modeVideo: "Video", modeAudio: "Voice", modeText: "Write",
    yourRating: "Your rating", yourName: "Your name *", yourEmail: "Your email *", emailPrivate: "Your email won't be shown publicly.",
    yourRole: "Role / Company", rolePh: "CEO, Company X",
    yourPhoto: "Your photo (optional)", changePhoto: "Change photo", addPhoto: "Add photo",
    photoHint: "JPG, PNG or WebP, up to 5MB.", photoTooLarge: "Photo too large (max 5MB)",
    textPh: "Tell us a bit about your experience...",
    consent: "I authorize <strong>{{business}}</strong> to use this testimonial on their website and marketing, according to the <a>Privacy Policy</a> and <b>Terms of Service</b>. My email won't be shown publicly.",
    consentRequired: "Please confirm the authorization to publish your testimonial.",
    recordFirst: "Record your testimonial before submitting", fillNameEmail: "Fill in your name and email",
    submit: "Submit testimonial", errorSend: "Error submitting. Please try again.",
    paused: "This collection is paused. Contact whoever sent you the link.",
    pausedShort: "This collection is paused. Contact whoever sent you the link.",
    notFound: "Campaign not found",
  },
  thankyou: { title: "Thank you!", defaultMsg: "Your testimonial was submitted successfully. It means a lot — truly.", closeHint: "You can close this page now." },
  widget: { pinnedBadge: "Highlight", ratingLabel: "ratings" },
  pricing: {
    title: "Choose the right plan", sub: "Start free. Grow with confidence.",
    monthly: "Monthly", yearly: "Yearly", yearlyBadge: "-20%",
    freeName: "Free", freeDesc: "To test and collect your first testimonials.",
    proName: "Pro", proDesc: "For businesses growing with social proof.",
    growthName: "Growth", growthDesc: "For teams already selling with testimonials.",
    agencyName: "Agency", agencyDesc: "For agencies and multi-brand operators.",
    trialBadge: "14-day free trial",
    trialNote: "14 days free, no credit card. Pick how to pay after the trial.",
    startTrial: "Start 14-day free trial",
    monthEq: "That's {{value}}/mo — pay 10 months, use 12",
    features: {
      freeCollect: "Up to 10 text testimonials",
      freeMedia: "2 video/voice testimonials",
      freeCampaigns: "1 active campaign",
      freeWidget: "Widget with depoia branding",
      proUnlimited: "Unlimited testimonials (text, video, voice)",
      proCampaigns: "Unlimited campaigns",
      proNoBrand: "Widget without depoia branding",
      proAi: "AI transcript and highlight",
      proExport: "CSV export",
      proSupport: "Priority support",
      growthAll: "Everything in Pro, plus:",
      growthReels: "Export ready-to-post Reels/TikTok video",
      growthDigest: "Weekly email summary",
      growthMultiLang: "Walls in English and Portuguese",
      growthSupport: "Priority email support",
      agencyAll: "Everything in Growth, plus:",
      agencyBrands: "Multiple brands and clients in one account",
      agencyOnboarding: "1:1 guided onboarding",
      agencyWhatsapp: "WhatsApp support",
      agencyPriority: "Priority on new features",
    },
    current: "Current plan", subscribe: "Subscribe",
  },
  billing: {
    title: "Billing", sub: "See your plan, switch anytime and cancel on your own.",
    currentPlan: "Current plan",
    statusFree: "You're on the free plan.",
    statusTrial: "Free trial until {{date}}. Billing starts after that.",
    statusActive: "Active · next charge on {{date}}",
    statusCanceling: "Canceled · you keep access until {{date}}",
    statusPastDue: "Payment pending — please update your payment method.",
    needsCard: "Your free trial is running and we don't have a payment method yet. Add a card so you don't lose access when the trial ends.",
    addCard: "Add payment method", changeCard: "Change card", noCard: "No card saved",
    cardSaved: "Payment method saved!",
    cancel: "Cancel subscription", confirmCancel: "Yes, cancel", keepPlan: "Keep my plan",
    cancelConfirmTitle: "Cancel your subscription?",
    cancelConfirmDesc: "You keep full access until {{date}} and won't be charged again. You can resume before that date.",
    canceledToast: "Subscription canceled. You keep access until the end of the paid period.",
    resume: "Resume subscription", resumedToast: "Subscription resumed!",
    changePlanTitle: "Change plan",
    changePlanDesc: "The switch applies right away. Stripe prorates what you already paid.",
    switchTo: "Switch to this plan",
    switchConfirmTitle: "Switch to {{plan}}?",
    switchConfirmDesc: "The change happens now. You get a credit or a prorated charge for the remaining days.",
    planChanged: "Plan changed to {{plan}}!",
    invoices: "Invoices", receipt: "Receipt",
    invStatus: { paid: "Paid", open: "Open", draft: "Draft", void: "Void", uncollectible: "Uncollectible" },
    genericError: "We couldn't complete that. Please try again.",
  },
  legal: {
    privacyTitle: "Privacy Policy", termsTitle: "Terms of Service",
    lastUpdate: "Last updated: August 2026",
    seeTerms: "See Terms of Service", seePrivacy: "See Privacy Policy",
  },
  integrations: {
    kicker: "No-code guides",
    title: "Paste depoia on any site in 30 seconds.",
    subtitle: "One iframe snippet. Zero plugins. Pick your platform and follow the step-by-step.",
    footerLink: "Integrations",
    snippetLabel: "Universal snippet (SEO-friendly)",
    iframeLabel: "Alternative · iframe",
    iframeHint: "Use it on platforms that block <script> (Wix, Notion). Looks the same, but Google can't read the testimonials.",
    replaceHint: "Replace \"sua-marca\" with your campaign slug (find it under Dashboard → Campaign → Embed code).",
    copied: "Snippet copied!",
    tipLabel: "Tip:",
    helpTitle: "Need a hand?",
    helpDesc: "Email us and we'll install it with you.",
    ctaTitle: "Don't have a campaign yet?",
    ctaSub: "Create a free account, set up your campaign in 2 minutes and come back here to paste the widget.",
    platforms: {
      wordpress: {
        name: "WordPress",
        intro: "Works with any theme. The snippet goes inside a Custom HTML block.",
        step1: "In the WordPress dashboard, edit the page or post where you want the testimonials to appear.",
        step2: "Click <strong>+ Add block</strong> and search for <strong>Custom HTML</strong>.",
        step3: "Paste the depoia snippet inside the block.",
        step4: "Click <strong>Update</strong> or <strong>Publish</strong>. The wall is live.",
        tip: "Using Elementor? Drop the <em>HTML</em> widget and paste the same snippet inside it.",
      },
      webflow: {
        name: "Webflow",
        intro: "depoia shows up as a native <em>Embed</em>. Zero JavaScript to configure.",
        step1: "Open the Webflow Designer and navigate to the target page.",
        step2: "Drag the <strong>Embed</strong> element (Components → Advanced) where the wall should appear.",
        step3: "Paste the snippet in the code editor and click <strong>Save & Close</strong>.",
        step4: "Hit <strong>Publish</strong> in the top-right corner.",
        tip: "Webflow Embed has a 10,000-char limit — depoia's snippet uses less than 200. You're safe.",
      },
      shopify: {
        name: "Shopify",
        intro: "Show testimonials on the homepage, product page or About — no theme editing needed.",
        step1: "In Shopify admin, go to <strong>Online store → Pages</strong> (or <strong>Customize</strong> for the home).",
        step2: "Add a <strong>Custom HTML</strong> section, or edit the page with the source-code editor.",
        step3: "Paste the depoia snippet and save.",
        step4: "Preview the store to confirm. The wall is responsive on mobile automatically.",
        tip: "On Dawn/Sense themes, use the <em>Custom Liquid</em> section — same behavior.",
      },
      wix: {
        name: "Wix",
        intro: "Wix blocks scripts, but depoia's iframe passes through <em>Embed HTML</em>.",
        step1: "In the Wix editor, click <strong>+ Add</strong> → <strong>Embed</strong> → <strong>Embed HTML</strong>.",
        step2: "Choose the <strong>Code</strong> option and paste the depoia snippet.",
        step3: "Resize the embed box so the wall fits (recommended: 100% width, 640px height).",
        step4: "Click <strong>Publish</strong> in the top-right corner.",
        tip: "On Wix Studio, use the <em>Custom Element</em> or <em>Embed HTML</em> component — works the same.",
      },
      squarespace: {
        name: "Squarespace",
        intro: "Requires a <em>Business</em> plan or higher (needed for the Code Block).",
        step1: "Edit the page and click the <strong>+</strong> button to add a block.",
        step2: "Choose the <strong>Code</strong> block and set language to <strong>HTML</strong>.",
        step3: "Paste the depoia snippet and uncheck <em>Display Source</em>.",
        step4: "Click outside the block and save. Publish the page.",
        tip: "If the wall is clipped, bump the <code>height=\"800\"</code> attribute in the iframe.",
      },
      framer: {
        name: "Framer",
        intro: "Framer supports iframes natively through the <em>Embed</em> component.",
        step1: "In the Framer editor, drag the <strong>Embed</strong> component (Insert → Embed) into the page.",
        step2: "Paste the depoia snippet in the <em>HTML</em> field on the right panel.",
        step3: "Publish the site with <strong>Publish</strong>.",
        tip: "Set the Embed width to <em>Fill</em> and height fixed at 640px for the best mobile look.",
      },
      notion: {
        name: "Notion",
        intro: "Perfect for public Notion pages (portfolios, wikis, simple landing pages).",
        step1: "Paste your public wall link in Notion — e.g. <code>https://depoia.com.br/w/sua-marca</code>.",
        step2: "Choose <strong>Create embed</strong> from the popup menu.",
        step3: "Resize the block by dragging the bottom handle. Publish the page.",
        tip: "Notion doesn't allow advanced JS iframes — depoia's widget is optimized to run natively.",
      },
      carrd: {
        name: "Carrd",
        intro: "The fastest way to add real social proof to a landing page.",
        step1: "Add an <strong>Embed</strong> element to your page (Pro Standard plan or higher required).",
        step2: "Pick type <strong>Code</strong>, style <strong>Hidden</strong> or <strong>Inline</strong>, and paste the snippet.",
        step3: "Save and publish. The widget shows up instantly.",
        tip: "Need a taller wall? Bump the <code>height</code> attribute directly in the snippet.",
      },
      bubble: {
        name: "Bubble",
        intro: "Bubble accepts raw HTML on any page via the <em>HTML</em> element.",
        step1: "In the Bubble editor, drag the <strong>HTML</strong> element onto the page.",
        step2: "Paste the depoia snippet into the <em>HTML</em> field of the element's properties.",
        step3: "Preview and deploy. Zero extra config.",
        tip: "Set element width to 100% of the container for a fully responsive wall on any breakpoint.",
      },
      html: {
        name: "Plain HTML",
        intro: "Any static site, framework or custom landing. Paste it in the HTML and you're done.",
        step1: "Open the HTML file of the page where testimonials should appear.",
        step2: "Paste the snippet where the wall should render. Save and deploy.",
        tip: "Works with Next.js, Astro, Hugo, Jekyll, Vite, etc. Drop it inside your JSX or template.",
      },
    },
  },
};

i18n.use(initReactI18next).init({
  resources: { pt: { translation: pt }, "pt-BR": { translation: pt }, en: { translation: en } },
  fallbackLng: "pt",
  supportedLngs: ["pt", "pt-BR", "en"],
  interpolation: { escapeValue: false },
});

// Resolve initial locale using the new priority chain (cookie -> URL -> Accept-Language -> Geo -> pt)
// and apply it BEFORE the app mounts. See /app/frontend/src/lib/locale.js.
(async () => {
  try {
    if (typeof window === "undefined") return;
    const { resolveLocale, setCookieLocale } = await import("@/lib/locale");
    const { locale, source } = await resolveLocale({ pathname: window.location.pathname });
    if (i18n.language?.slice(0, 2) !== locale) {
      await i18n.changeLanguage(locale);
    }
    // Persist to cookie whenever the source is NOT already the cookie itself.
    if (source !== "cookie") setCookieLocale(locale);
  } catch {
    // fallback: keep the default language
  }
})();

export default i18n;
